import styled from 'styled-components';
import { Menu } from 'antd';

export const StyledMenuNotificacoes = styled(Menu)`
  .menu-item__custom {
    height: auto;
    padding: 0 !important;
    margin: 0;
    line-height: unset;
  }

  .menu-item__custom.ant-dropdown-menu-item:hover,
  .menu-item__custom.ant-dropdown-menu-submenu-title:hover {
    background-color: unset;
    border-radius: unset;
    color: unset;
  }

  .container-notificacoes {
    max-height: 50vh;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      box-shadow: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background-color: var(--color-scrollbar) !important;
      border: 3px solid var(--color-white) !important;
    }

    ::-webkit-resizer {
      display: none;
    }

    ::-webkit-scrollbar-button {
      display: block;
    }
  }

  .container-notificacoes:hover {
    cursor: pointer;
  }

  .dropdown-menu-item,
  .dropdown-menu-item-selected {
    display: flex;
    min-width: 290px;
    margin: 7px;
    padding: 2px 4px 2px 0px;
    border: 1px solid rgb(240, 240, 240); /* stylelint-disable-line */
    border-radius: 20px;
    min-height: 34px !important;
  }

  .container-notificacoes
    > .dropdown-menu-item-selected
    > .flex-column
    > div
    > .nome-pessoa {
    color: var(--color-white-gray);
  }

  .container-notificacoes
    > .dropdown-menu-item-selected
    > .flex-column
    > div
    > .nome-empresa {
    color: var(--color-white-gray);
  }

  .container-notificacoes
    > .dropdown-menu-item
    > .flex-column
    > div
    > .nome-pessoa {
    color: rgba(0, 0, 0, 0.65); /* stylelint-disable-line */
  }

  .container-notificacoes
    > .dropdown-menu-item
    > .flex-column
    > div
    > .nome-empresa {
    color: rgba(0, 0, 0, 0.65); /* stylelint-disable-line */
  }

  .avatar {
    margin-left: 1px;
    margin-top: 1px;
  }

  .dropdown-menu-item:hover,
  .dropdown-menu-submenu-title:hover {
    background-color: var(--color-gray-light);
    border-radius: 25px;
    color: var(--color-scrollbar);
  }

  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu-title {
    padding: 2px 40px 2px 10px;
  }

  .date-text {
    color: var(--color-secondary-light);
    font-size: 0.563rem;
  }

  &:before {
    content: unset !important;
  }
  @media (max-width: 359px) {
    max-width: calc(100% - 20px);
    right: 10px;
    left: 10px;
  }
  @media (min-width: 360px) {
    max-width: 300px;
    &:before {
      content: ' ' !important;
    }
  }

  @media (min-width: 576px) {
    max-width: 360px;
    .dropdown-menu-item,
    .dropdown-menu-item-selected {
      padding: 2px 15px 2px 0px;
    }
  }
  @media (min-width: 768px) {
    max-width: 500px;
  }

  @media (min-width: 992px) {
    max-width: 600px;
  }

  @media (min-width: 1200px) {
    max-width: 700px;
  }
`;

export const StyledMenu = styled(Menu)`
  .menu-item__custom {
    height: auto;
    padding: 0 !important;
    margin: 0;
    line-height: unset;
  }

  .menu-item__custom.ant-dropdown-menu-item:hover,
  .menu-item__custom.ant-dropdown-menu-submenu-title:hover {
    background-color: unset;
    border-radius: unset;
    color: unset;
  }

  .container-vinculos {
    max-height: 29vh;
    overflow-y: auto;
    overflow-x: hidden;

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      box-shadow: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background-color: var(--color-scrollbar) !important;
      border: 3px solid var(--color-white) !important;
    }

    ::-webkit-resizer {
      display: none;
    }

    ::-webkit-scrollbar-button {
      display: block;
    }
  }

  @media (min-width: 1200px) {
    .container-vinculos {
      max-height: 38vh;
      overflow-y: auto;

      ::-webkit-scrollbar {
        width: 8px;
      }

      ::-webkit-scrollbar-track {
        box-shadow: transparent;
        border-radius: 2px;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background-color: var(--color-scrollbar);
        border: 3px solid var(--color-white) !important;
      }

      ::-webkit-resizer {
        display: none;
      }

      ::-webkit-scrollbar-button {
        display: block;
      }
    }
  }

  .container-vinculos:hover {
    cursor: pointer;
  }

  .dropdown-menu-item,
  .dropdown-menu-item-selected {
    display: flex;
    min-width: 290px;
    margin: 7px;
  }

  .container-vinculos
    > .dropdown-menu-item-selected
    > .flex-column
    > div
    > .nome-pessoa {
    color: var(--color-white-gray);
  }

  .container-vinculos
    > .dropdown-menu-item-selected
    > .flex-column
    > div
    > .nome-empresa {
    color: var(--color-white-gray);
  }

  .container-vinculos
    > .dropdown-menu-item
    > .flex-column
    > div
    > .nome-pessoa {
    /* stylelint-disable-next-line function-blacklist */
    color: rgba(0, 0, 0, 0.65);
  }

  .container-vinculos
    > .dropdown-menu-item
    > .flex-column
    > div
    > .nome-empresa {
    /* stylelint-disable-next-line function-blacklist */
    color: rgba(0, 0, 0, 0.65);
  }

  .avatar {
    margin-left: 1px;
    margin-top: 1px;
  }

  .spotlight-text {
    font-weight: bold;
    color: var(--color-primary) !important;
  }

  .dropdown-menu-item:hover,
  .dropdown-menu-submenu-title:hover {
    background-color: var(--color-gray-light);
    border-radius: 25px;
    color: var(--text-color);
  }

  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu-title {
    padding: 2px 40px 2px 10px;
  }
`;
